;(function () {

"use strict";

var SelectInputView = Backbone.View.extend({
  initialize: function () {
    this.val = this.$el.find('select').val();
    this.$input = this.$el.find('input[type="text"]');
    this.$input.val(this.val);
  },
  events: {
    'change select': function (e) {
      console.log('changed');
      this.$input.val(this.$el.find('select').val());
    }
  }
});

module.exports = SelectInputView;

}());